import { BaseSelectProps, Select } from "@mui/material";
import { PropsWithChildren } from "react";

interface Props extends BaseSelectProps {
  id: string;
  label?: string;
  required?: boolean;
}

export default function SelectInput(props: PropsWithChildren<Props>) {
  const { id, label, required, children, ...rest } = props;
  return (
    <div className="flex flex-col">
      {label && (
        <label className="field-label" htmlFor={id}>
          {label}
          {required && (
            <span className="text-red" aria-hidden="true">
              &nbsp;*
            </span>
          )}
        </label>
      )}
      <Select
        slotProps={{
          input: {
            className: "!rounded-xl !bg-white !px-4 !py-3",
          },
        }}
        variant="outlined"
        inputProps={{ id }}
        {...rest}
      >
        {children}
      </Select>
    </div>
  );
}
